import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Pagination,
  DateRangePicker,
  Select,
  format_date,
  saveAs,
  XLSX,
  GET,
  POST,
  PUT,
  DELETE,
  Modal,
  t,
  can,
} from "../../components/CustomComponent.js";
import { withRouter } from "../../components/withRouter.js";
// ประเภทประกาศใช้ชุดกลางร่วมกับหน้าเพิ่ม-แก้ไขทรัพย์ ส่วนประเภททรัพย์เป็นข้อมูล master
// ในฐานข้อมูล จึงดึงจาก API มาเก็บไว้ใน state แทนการอ่านจากไฟล์ค่าคงที่
import {
  DEALS,
  PROPERTY_STATUS,
  PARKING_TYPES,
  parkingTypes,
  parkingCount,
  contractUnitMeta,
  statusMeta,
  amenityMeta,
  facilityMeta,
  decorationMeta,
  furnishMeta,
  tagMeta,
  directionMeta,
  nearbyMeta,
} from "../../components/asset_option.js";
import "../../assets/css/property.css";

/* ============================================================================
 * จัดการทรัพย์ › ทั้งหมด  (/ad/assets)
 * หน้ารวมทรัพย์ทั้งหมด : ตัวกรองการค้นหา + สรุปตัวกรอง + เงื่อนไขที่บันทึกไว้
 * + ผลการค้นหาแบบรายการ/การ์ด พร้อมเลือกหลายรายการและส่งออก Excel
 *
 * การกรอง เรียงลำดับ และแบ่งหน้า ทำที่ฝั่ง API ทั้งหมด — ข้อมูลจริงมีได้หลักพันรายการ
 * จึงไม่ดึงมาทั้งก้อนแล้วค่อยกรองในเบราว์เซอร์
 *
 * ต่อกับ API แล้ว :
 *   GET    admin/assets                 (Get — ตัวกรองทั้งหมดส่งไปเป็น query)
 *   GET    admin/assets/zones           (ตัวเลือกเขต/แขวง เท่าที่มีทรัพย์อยู่จริง)
 *   GET    admin/asset-categories       (ตัวเลือกประเภททรัพย์ — ข้อมูล master)
 *   GET    admin/users                  (ตัวเลือกผู้ดูแล)
 *   PUT    admin/assets/:uid/favorite   (กดหัวใจ)
 *   PUT    admin/assets/:uid/archive    (เก็บเข้ากรุ)
 *   POST   admin/assets/:uid/duplicate  (ทำสำเนาประกาศ)
 *   DELETE admin/assets/:uid            (ลบ)
 * ========================================================================== */

const PAGE_SIZE = 8;

/* --------------------------------------------------------------- design tokens */
/* สถานะทรัพย์ใช้ชุดกลางจาก asset_option.js (statusMeta / PROPERTY_STATUS) */

/* สถานะการเผยแพร่ — ใช้เฉพาะในโมดัลรายละเอียด (รายการปกติดูที่สถานะทรัพย์พอ) */
const PUBLISH_META = {
  published: { label: "pub_published", color: "#047857", tint: "#d1fae5", icon: "\uf058" },
  scheduled: { label: "pub_scheduled", color: "#b45309", tint: "#fef3c7", icon: "\uf017" },
  draft: { label: "pub_draft", color: "#4b5563", tint: "#e5e7eb", icon: "\uf15c" },
};

/* ภาษาของรายละเอียดประกาศในโมดัล — แสดงเฉพาะภาษาที่กรอกไว้จริง */
const DESC_LANGS = [
  { value: "th", label: "lang_thai", field: "description_th" },
  { value: "en", label: "lang_english", field: "description_en" },
  { value: "cn", label: "lang_chinese", field: "description_cn" },
];

const SORTS = [
  { value: "updated_desc", label: "sort_updated_desc" },
  { value: "updated_asc", label: "sort_updated_asc" },
  { value: "rent_asc", label: "sort_rent_asc" },
  { value: "rent_desc", label: "sort_rent_desc" },
  { value: "price_asc", label: "sort_price_asc" },
  { value: "price_desc", label: "sort_price_desc" },
  { value: "area_desc", label: "sort_area_desc" },
  { value: "views_desc", label: "sort_views_desc" },
];

const ROOM_OPTIONS = ["1", "2", "3", "4", "5"]; // "5" = 5 ห้องขึ้นไป

/* ------------------------------------------------------------------ helpers */
/* ที่จอดรถ — "รถยนต์ 2 คัน · มอเตอร์ไซค์" ระบุจำนวนไว้จึงต่อท้าย ไม่ระบุก็โชว์แค่ประเภท */
const parkingLabel = (item) =>
  parkingTypes(item)
    .map((e) => (parkingCount(item, e) ? `${t(e.label)} ${parkingCount(item, e)} ${t("car_unit")}` : t(e.label)))
    .join(" · ");

const EMPTY_FILTER = {
  deals: [],
  type: "",
  keyword: "",
  status: "",
  district: "",
  subdistrict: "",
  price_min: "",
  price_max: "",
  rent_min: "",
  rent_max: "",
  area_min: "",
  area_max: "",
  bedroom: "",
  bathroom: "",
  // ที่จอดรถกรองด้วยประเภทที่จอดได้ ติ๊กทั้งคู่ = ต้องจอดได้ทั้งสองแบบ
  parking_motorcycle: false,
  parking_car: false,
  available: { start_date: null, end_date: null },
  admin: "",
  has_photo: false,
  has_video: false,
  co_agent: false,
};

/* หน้าอื่นลิงก์เข้ามาพร้อมการเรียงลำดับได้ เช่นการ์ด "10 ทรัพย์ที่มีคนดูสูงสุด"
   ในแดชบอร์ดส่ง ?sort=views_desc มาเพื่อให้ดูอันดับต่อจากที่ 10 ได้ทันที
   รับเฉพาะค่าที่มีในรายการจริง กัน query string มั่ว ๆ ทำให้ API ตีความผิด */
const linkedSort = (search) => {
  const sort = new URLSearchParams(search || "").get("sort");
  return SORTS.some((s) => s.value === sort) ? sort : "";
};

/* เงื่อนไขค้นหาที่บันทึกไว้ — เป็นความสะดวกส่วนตัวของผู้ใช้บนเครื่องนั้น ๆ
   ยังไม่ผูกกับบัญชีในฐานข้อมูล เปลี่ยนเครื่องแล้วจะไม่ตามไปด้วย */
const SAVED_KEY = "mn-asset-searches";

const loadSaved = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(SAVED_KEY) || "[]");
    return Array.isArray(saved) ? saved : [];
  } catch (e) {
    return [];
  }
};

const storeSaved = (saved) => {
  try {
    localStorage.setItem(SAVED_KEY, JSON.stringify(saved));
  } catch (e) {}
};

// หัวใจแบบ SVG — favorite = ทึบสีขาวบนวงกลมชมพู, ยังไม่ favorite = เส้นขอบสีเทา (ฟอนต์ fa-light มีแต่แบบโปร่ง)
const HEART_PATH =
  "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z";

const num = (v) => (v === "" || v === null || v === undefined ? null : Number(String(v).replace(/,/g, "")));
// จำนวนเต็มพร้อมคอมมา ไม่มีทศนิยม
const money = (v) => Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });
const decimal = (v) => Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: 2 });
const dateTH = (d) => (d ? format_date(d, "dd/mm/yyyy", "th") : "-");
const isRentDeal = (deals) => (deals || []).includes("rent");
const isSaleDeal = (deals) => (deals || []).includes("sale");
// ชื่อประเภททรัพย์มาจากฐานข้อมูล ไม่ได้อยู่ในไฟล์แปล จึงเลือกภาษาเองตามที่ผู้ใช้ตั้งไว้
const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const categoryName = (category) => (category ? (isTh() ? category.name_th : category.name_en || category.name_th) : "-");
// DateRangePicker คืนค่าเป็น Date — API รับเป็น YYYY-MM-DD
const isoDate = (value) => (value ? format_date(value, "yyyy-mm-dd", "en") : "");

class PropertyAll extends Component {
  constructor(props) {
    super(props);
    // เปิดหน้ามาไม่กรองอะไรเลย — ตั้งต้นเป็น "ให้เช่า" ไว้จะตัดทรัพย์ขายออกเงียบ ๆ
    // จนยอดที่เห็นไม่ตรงกับจำนวนทรัพย์จริงในระบบ
    const sort = linkedSort(props.router?.location?.search);
    const filter = { ...EMPTY_FILTER };

    this.state = {
      filter: { ...filter },   // ตัวกรองในฟอร์ม (ยังไม่กดค้นหา)
      applied: { ...filter },  // ตัวกรองที่ใช้กับผลลัพธ์ปัจจุบัน
      sort: sort || "updated_desc",
      view: "list",                  // list | grid
      page: 1,
      data: [],
      count: 0,
      selected: [],
      saved: loadSaved(),
      saved_open: false,
      // ตัวเลือกของตัวกรอง โหลดครั้งเดียวตอนเปิดหน้า
      categories: [],
      admins: [],
      zones: [],
      menu_open: "",                 // uid ของการ์ดที่เปิดเมนู "..."
      fav_pop: "",                   // uid ที่กำลังเล่น effect ปุ่มหัวใจ
      // โมดัลรายละเอียด — detail เป็นข้อมูลเต็มจาก GET admin/assets/:uid
      // (รายการในหน้ารวมเป็นข้อมูลย่อ ไม่มีเจ้าของ / เอกสาร / รายละเอียดประกาศ)
      detail: null,
      detail_open: false,
      detail_photo: 0,               // รูปที่กำลังดูอยู่ในแกลเลอรี
      detail_lang: "th",             // แท็บภาษาของรายละเอียดประกาศ
    };
  }

  componentDidMount() {
    loading(false);
    this.GetMaster();
    this.Get(1);
  }

  /* ตัวเลือกของตัวกรอง — ประเภททรัพย์ / ผู้ดูแล / ทำเล ดึงจากข้อมูลจริงทั้งหมด
     ทำเลดึงเฉพาะเขตที่มีทรัพย์อยู่จริง จะได้ไม่ต้องเลื่อนหาในรายชื่อทั้งประเทศ */
  GetMaster = async () => {
    const [categories, admins, zones] = await Promise.all([
      GET("admin/asset-categories", { page: 0, is_active: true }),
      GET("admin/users", { page: 0, is_active: true }),
      GET("admin/assets/zones", null),
    ]);

    this.setState({
      categories: categories?.status ? categories.data || [] : [],
      admins: admins?.status ? admins.data || [] : [],
      zones: zones?.status ? zones.data || [] : [],
    });
  };

  componentWillUnmount() {
    clearTimeout(this.fav_timer);
  }

  /* ------------------------------------------------------------ ดึงผลการค้นหา */
  Get = async (page = 1, filter = this.state.filter, sort = this.state.sort) => {
    loading(true);
    const result = await GET("admin/assets", this.query(page, filter, sort));
    loading(false);

    if (!result?.status) return;

    this.setState({
      data: result.data || [],
      count: result.pagination?.count || 0,
      page,
      applied: { ...filter },
      sort,
      menu_open: "",
    });
  };

  /* แปลงตัวกรองในฟอร์มเป็น query ของ API
     ตัดคีย์ที่ไม่ได้ใช้ทิ้ง เพราะ buildUrl ต่อทุกคีย์ที่ส่งเข้าไปเป็น query string หมด */
  query = (page, filter, sort, extra = {}) => {
    const params = {
      page,
      page_size: PAGE_SIZE,
      sort,
      deals: (filter.deals || []).join(","),
      type: filter.type,
      data_search: filter.keyword,
      status: filter.status,
      district: filter.district,
      subdistrict: filter.subdistrict,
      price_min: filter.price_min,
      price_max: filter.price_max,
      rent_min: filter.rent_min,
      rent_max: filter.rent_max,
      area_min: filter.area_min,
      area_max: filter.area_max,
      bedroom: filter.bedroom,
      bathroom: filter.bathroom,
      parking_motorcycle: filter.parking_motorcycle,
      parking_car: filter.parking_car,
      available_start: isoDate(filter.available?.start_date),
      available_end: isoDate(filter.available?.end_date),
      admin_uid: filter.admin,
      has_photo: filter.has_photo,
      has_video: filter.has_video,
      co_agent: filter.co_agent,
      ...extra,
    };

    return Object.fromEntries(
      Object.entries(params).filter(([, value]) => value !== "" && value !== false && value !== null && value !== undefined)
    );
  };

  /* ------------------------------------------------------------ จัดการตัวกรอง */
  setFilter = (patch) => this.setState((prev) => ({ filter: { ...prev.filter, ...patch } }));

  // เปลี่ยนเขต/อำเภอ → ล้างแขวง/ตำบลเดิม เพราะตัวเลือกผูกกับเขตใหม่
  setDistrict = (district) => this.setFilter({ district, subdistrict: "" });

  clearFilters = () => this.setState({ filter: { ...EMPTY_FILTER } });

  clearAll = () => this.setState({ filter: { ...EMPTY_FILTER }, selected: [] }, () => this.Get(1, { ...EMPTY_FILTER }));

  // ลบชิปสรุปตัวกรอง 1 ตัว แล้วค้นหาใหม่ทันที
  removeChip = (patch) => {
    const filter = { ...this.state.applied, ...patch };
    this.setState({ filter }, () => this.Get(1, filter));
  };

  applySaved = (saved) => {
    const filter = { ...EMPTY_FILTER, ...saved.filter };
    this.setState({ filter, saved_open: false }, () => this.Get(1, filter));
  };

  SaveSearch = async () => {
    const chips = this.filterChips(this.state.filter);
    if (!chips.length) {
      alert("", "warning", t("warning"), t("save_search_empty"));
      return;
    }
    const name = chips.map((c) => c.text).join(" · ");
    if (await alert("", "info", t("save_search"), `${t("save_search_confirm")}\n${name}`, t("confirm"), t("cancel"))) {
      this.setState(
        (prev) => ({ saved: [{ uid: `s${Date.now()}`, name, filter: { ...prev.filter } }, ...prev.saved].slice(0, 8) }),
        () => storeSaved(this.state.saved)
      );
      alert("", "success", t("success"), t("save_search_done"));
    }
  };

  /* ------------------------------------------------- สรุปตัวกรองเป็นชิปย่อ ๆ */
  filterChips = (f) => {
    const chips = [];
    const push = (text, patch) => chips.push({ text, patch });

    (f.deals || []).forEach((value) =>
      push(t(DEALS.find((d) => d.value === value)?.label || ""), { deals: (f.deals || []).filter((e) => e !== value) })
    );
    if (f.type) push(categoryName(this.state.categories.find((e) => e.code === f.type)), { type: "" });
    if (f.keyword) push(f.keyword, { keyword: "" });
    if (f.status) push(`${t("status")}: ${t(statusMeta(f.status).label)}`, { status: "" });
    if (f.district) push(f.district, { district: "", subdistrict: "" });
    if (f.subdistrict) push(f.subdistrict, { subdistrict: "" });
    if (f.price_min || f.price_max)
      push(`${t("sale_price")} ${money(num(f.price_min) || 0)} - ${f.price_max ? money(num(f.price_max)) : "∞"}`, { price_min: "", price_max: "" });
    if (f.rent_min || f.rent_max)
      push(`${t("rent_price")} ${money(num(f.rent_min) || 0)} - ${f.rent_max ? money(num(f.rent_max)) : "∞"}`, { rent_min: "", rent_max: "" });
    if (f.area_min || f.area_max)
      push(`${t("area_size")} ${f.area_min || 0} - ${f.area_max || "∞"} ${t("sqm")}`, { area_min: "", area_max: "" });
    if (f.bedroom) push(`${f.bedroom}${Number(f.bedroom) >= 5 ? "+" : ""} ${t("bed_unit")}`, { bedroom: "" });
    if (f.bathroom) push(`${f.bathroom}${Number(f.bathroom) >= 5 ? "+" : ""} ${t("bath_unit")}`, { bathroom: "" });
    PARKING_TYPES.forEach((item) => f[item.key] && push(`${t("parking")}: ${t(item.label)}`, { [item.key]: false }));
    if (f.available?.start_date)
      push(`${t("available_date")} ${dateTH(f.available.start_date)}${f.available.end_date ? ` - ${dateTH(f.available.end_date)}` : ""}`,
        { available: { start_date: null, end_date: null } });
    if (f.admin) push(this.state.admins.find((a) => a.uid === f.admin)?.full_name || "", { admin: "" });
    if (f.has_photo) push(t("has_photo"), { has_photo: false });
    if (f.has_video) push(t("has_video"), { has_video: false });
    if (f.co_agent) push(t("co_agent_open"), { co_agent: false });
    return chips;
  };

  /* ------------------------------------------------------------ เลือก / โปรด */
  toggleSelect = (uid) =>
    this.setState((prev) => ({
      selected: prev.selected.includes(uid) ? prev.selected.filter((e) => e !== uid) : [...prev.selected, uid],
    }));

  toggleSelectPage = () =>
    this.setState((prev) => {
      const ids = prev.data.map((e) => e.uid);
      const allOn = ids.length > 0 && ids.every((id) => prev.selected.includes(id));
      return {
        selected: allOn ? prev.selected.filter((id) => !ids.includes(id)) : [...new Set([...prev.selected, ...ids])],
      };
    });

  // สลับที่หน้าจอทันทีเพื่อไม่ให้ปุ่มหน่วง แล้วค่อยยืนยันกับ API
  // (รายการโปรดเป็นของผู้ใช้แต่ละคน ไม่ใช่ข้อมูลของทรัพย์)
  toggleFavorite = async (item) => {
    clearTimeout(this.fav_timer);
    this.setState((prev) => ({
      fav_pop: item.uid, // ติดคลาสไว้ให้ CSS เล่น effect เด้ง + วงกระเพื่อม
      data: prev.data.map((e) => (e.uid === item.uid ? { ...e, favorite: !e.favorite } : e)),
    }));
    this.fav_timer = setTimeout(() => this.setState({ fav_pop: "" }), 600);

    const result = await PUT("admin/assets/" + item.uid + "/favorite", null);
    if (result?.status) return;

    // ยิงไม่สำเร็จ — คืนค่าเดิมให้ตรงกับฐานข้อมูล
    this.setState((prev) => ({
      data: prev.data.map((e) => (e.uid === item.uid ? { ...e, favorite: item.favorite } : e)),
    }));
  };

  /* --------------------------------------------------------- action บนการ์ด */
  // รายการในหน้ารวมเป็นข้อมูลย่อ จึงต้องดึงรายละเอียดเต็มก่อนเปิดโมดัล
  ViewDetail = async (item) => {
    this.setState({ menu_open: "" });

    loading(true);
    const result = await GET("admin/assets/" + item.uid, null);
    loading(false);

    if (!result?.status) return;

    this.setState({ detail: result.data, detail_open: true, detail_photo: 0, detail_lang: "th" });
  };

  // ปิดแล้วยังคง detail ไว้ ให้ modal เฟดออกได้โดยเนื้อหาไม่หายวูบก่อน
  CloseDetail = () => this.setState({ detail_open: false });

  // ใช้ฟอร์มเดียวกับหน้าเพิ่มทรัพย์ — มี uid บน route = เข้าโหมดแก้ไข
  Edit = (item) => {
    this.setState({ menu_open: "" });
    this.props.router.navigate(`/ad/assets/${item.uid}/edit`);
  };

  // สำเนาจะเป็นแบบร่างและได้รหัสทรัพย์ใหม่เสมอ ผู้ใช้ค่อยไปแก้รายละเอียดต่อ
  Duplicate = async (item) => {
    this.setState({ menu_open: "" });
    if (!(await alert("", "info", t("duplicate"), `${t("duplicate_confirm")} ${item.code}`, t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await POST("admin/assets/" + item.uid + "/duplicate", null);
    loading(false);

    if (!result?.status) return;

    await this.Get(1, this.state.applied);
    alert("", "success", t("success"), `${t("duplicate_done")} ${result.data?.code || ""}`);
  };

  CopyLink = (item) => {
    this.setState({ menu_open: "" });
    const url = `${window.location.origin}/ad/assets?uid=${item.uid}`;
    navigator.clipboard?.writeText(url);
    alert("", "success", t("success"), t("link_copied"));
  };

  // เก็บเข้ากรุ = ซ่อนจากรายการปกติแต่ยังไม่ลบ (ยังดึงกลับมาได้)
  Archive = async (item) => {
    this.setState({ menu_open: "" });
    if (!(await alert("", "warning", t("archive"), `${t("archive_confirm")} ${item.code}`, t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await PUT("admin/assets/" + item.uid + "/archive", { is_archived: true });
    loading(false);

    if (!result?.status) return;

    await this.Get(1, this.state.applied);
    alert("", "success", t("success"), t("archive_done"));
  };

  Delete = async (item) => {
    this.setState({ menu_open: "" });
    if (!(await alert("", "warning", t("delete_item"), `${t("delete_desc")}\n${item.code}`, t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await DELETE("admin/assets/" + item.uid, null);
    loading(false);

    if (!result?.status) return;

    this.setState((prev) => ({ selected: prev.selected.filter((uid) => uid !== item.uid) }));
    await this.Get(this.state.page, this.state.applied);
    alert("", "success", t("success"), t("delete_done"));
  };

  /* --------------------------------------------------------------- ส่งออก Excel */
  // ส่งออกทุกรายการที่ตรงกับตัวกรอง (ไม่ใช่เฉพาะหน้าที่เปิดอยู่) จึงต้องดึงจาก API อีกรอบ
  // ด้วย page = 0 ซึ่งฝั่ง API หมายถึง "เอาทั้งหมด ไม่แบ่งหน้า"
  ExportExcel = async () => {
    const { selected } = this.state;

    loading(true);
    const result = await GET("admin/assets", this.query(0, this.state.applied, this.state.sort, { page: 0 }));
    loading(false);

    if (!result?.status) return;

    const source = result.data || [];
    const rows = (selected.length ? source.filter((e) => selected.includes(e.uid)) : source).map((item, i) => ({
      [t("no")]: i + 1,
      [t("code")]: item.code,
      [t("property_name")]: item.title,
      [t("property_type")]: categoryName(item.asset_category),
      [t("deal_type")]: DEALS.filter((d) => (item.deals || []).includes(d.value)).map((d) => t(d.label)).join(" + "),
      [t("status")]: t(statusMeta(item.status).label),
      [t("zone_district")]: item.district,
      [t("subdistrict")]: item.subdistrict,
      [t("bedrooms")]: item.bedroom || "-",
      [t("bathrooms")]: item.bathroom || "-",
      [`${t("area_size")} (${t("sqm")})`]: item.area || "-",
      [`${t("land_area")} (${t("sqw")})`]: item.land_area || "-",
      [t("parking")]: parkingLabel(item) || "-",
      [`${t("rent_price")} (${t("unit_baht")})`]: isRentDeal(item.deals) ? item.rent : "-",
      [t("contract_term")]: item.contract_term ? `${item.contract_term} ${t(contractUnitMeta(item.contract_unit).label)}` : "-",
      [`${t("sale_price")} (${t("unit_baht")})`]: isSaleDeal(item.deals) ? item.price : "-",
      [t("owner_admin")]: item.admin_name,
      [t("available_date")]: dateTH(item.available_at),
      [t("updated")]: dateTH(item.updated_at),
    }));

    if (!rows.length) {
      alert("", "warning", t("warning"), t("no_data"));
      return;
    }

    const sheet = XLSX.utils.json_to_sheet(rows);
    const book = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, sheet, "properties");
    const buffer = XLSX.write(book, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([buffer], { type: "application/octet-stream" }), `properties-${format_date(new Date(), "yyyy-mm-dd", "en")}.xlsx`);
  };

  /* ========================================================== render : ตัวกรอง */
  renderFilterPanel = () => {
    const { filter, saved, saved_open } = this.state;
    const subdistricts = this.state.zones.find((z) => z.district === filter.district)?.subdistricts || [];

    const minmax = (keyMin, keyMax, placeholderMin = "min", placeholderMax = "max") => (
      <div className="prop-minmax">
        <input
          type="text"
          className="prop-field"
          placeholder={t(placeholderMin)}
          value={filter[keyMin]}
          onChange={(e) => /^\d*$/.test(e.target.value) && this.setFilter({ [keyMin]: e.target.value })}
          onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
        />
        <span className="prop-minmax__sep">-</span>
        <input
          type="text"
          className="prop-field"
          placeholder={t(placeholderMax)}
          value={filter[keyMax]}
          onChange={(e) => /^\d*$/.test(e.target.value) && this.setFilter({ [keyMax]: e.target.value })}
          onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
        />
      </div>
    );

    // Select ของโปรเจกต์ — พิมพ์ค้นหาในตัวเลือกได้ (ใส่ option "ทั้งหมด" เองแทน default ของ component)
    const select = (key, options, extra = {}) => (
      <Select
        className="prop-field prop-select"
        default={false}
        placeholder={t("all")}
        value={filter[key]}
        options={[{ value: "", label: t("all") }, ...options]}
        onChange={(value) => this.setFilter({ [key]: value })}
        {...extra}
      />
    );

    const roomSelect = (key) =>
      select(key, ROOM_OPTIONS.map((n) => ({ value: n, label: n === "5" ? `${n}+` : n })));

    const check = (key, label) => (
      // key ของ React ใช้ชื่อฟิลด์ตรง ๆ — ไม่ซ้ำกันอยู่แล้วและช่วยตอนเรียกในลูป (ที่จอดรถ)
      <label key={key} className={`prop-check ${filter[key] ? "is-on" : ""}`}>
        <input type="checkbox" checked={filter[key]} onChange={(e) => this.setFilter({ [key]: e.target.checked })} />
        <span>{t(label)}</span>
      </label>
    );

    return (
      <div className="prop-card prop-in mb-3">
        <div className="prop-card__head">
          <span className="prop-title text-16">
            <span className="prop-title__dot" />
            <span className="icon me-1 text-14">{""}</span>
            {t("search_filters")}
          </span>
          <div className="d-flex align-items-center gap-2">
            <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.clearFilters}>
              <span className="icon text-12">{""}</span>
              {t("clear_filters")}
            </button>
            <div className="position-relative">
              <button
                type="button"
                className="prop-btn prop-btn--ghost prop-btn--sm"
                aria-expanded={saved_open}
                onClick={() => this.setState({ saved_open: !saved_open })}
              >
                <span className="icon text-12">{""}</span>
                {t("saved_filters")}
                <span className="icon text-10">{saved_open ? "" : ""}</span>
              </button>
              {saved_open && (
                <>
                  <div className="position-fixed" style={{ inset: 0, zIndex: 1040 }} onClick={() => this.setState({ saved_open: false })} />
                  <div className="prop-pop">
                    <div className="text-10 text-secondary px-2 pb-2">{t("saved_searches")}</div>
                    {saved.map((s) => (
                      <button key={s.uid} type="button" className="prop-pop__item" onClick={() => this.applySaved(s)}>
                        <span className="icon prop-saved__icon">{""}</span>
                        <span className="text-truncate">{s.name}</span>
                      </button>
                    ))}
                    {!saved.length && <div className="text-center text-secondary text-12 py-3">{t("no_data")}</div>}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="p-4">
          <div className="row g-3">
            {/* แถว 1 */}
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("deal_type")}</label>
              <div className="prop-seg">
                {DEALS.map((d) => {
                  const on = (filter.deals || []).includes(d.value);
                  return (
                    <button
                      key={d.value}
                      type="button"
                      aria-pressed={on}
                      className={`prop-seg__btn ${on ? "is-active" : ""}`}
                      onClick={() =>
                        this.setFilter({
                          deals: on
                            ? (filter.deals || []).filter((e) => e !== d.value)
                            : [...(filter.deals || []), d.value],
                        })
                      }
                    >
                      {t(d.label)}
                    </button>
                  );
                })}
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("property_type")}</label>
              {select("type", this.state.categories.map((c) => ({ value: c.code, label: categoryName(c) })))}
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("project_or_property_name")}</label>
              <div className="position-relative">
                <span className="icon prop-field-icon">{""}</span>
                <input
                  type="text"
                  className="prop-field prop-field--icon"
                  placeholder={t("search_project_placeholder")}
                  value={filter.keyword}
                  onChange={(e) => this.setFilter({ keyword: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                />
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("status")}</label>
              {select("status", PROPERTY_STATUS.map((e) => ({ value: e.value, label: t(e.label) })))}
            </div>

            {/* แถว 2 */}
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("zone_district")}</label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("all")}
                value={filter.district}
                options={[{ value: "", label: t("all") }, ...this.state.zones.map((z) => ({ value: z.district, label: z.district }))]}
                onChange={(value) => this.setDistrict(value)}
              />
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("subdistrict")}</label>
              {select("subdistrict", subdistricts.map((s) => ({ value: s, label: s })), { disabled: !filter.district })}
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("price_range_baht")}</label>
              {minmax("price_min", "price_max")}
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("rent_per_month_baht")}</label>
              {minmax("rent_min", "rent_max")}
            </div>

            {/* แถว 3 */}
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("area_size_sqm")}</label>
              {minmax("area_min", "area_max")}
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("bedrooms")}</label>
              {roomSelect("bedroom")}
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("bathrooms")}</label>
              {roomSelect("bathroom")}
            </div>
            {/* ที่จอดรถกรองเป็นประเภทที่จอดได้ ไม่ใช่จำนวนคัน — ติ๊กทั้งคู่ = ต้องจอดได้ทั้งสองแบบ */}
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("parking")}</label>
              <div className="d-flex flex-wrap gap-2">
                {PARKING_TYPES.map((item) => check(item.key, item.label))}
              </div>
            </div>

            {/* แถว 4 */}
            {/* prop-datefield ยกปฏิทินให้ลอยเหนือฟิลด์อื่นในแถวเดียวกัน */}
            <div className="col-xl-3 col-md-6 prop-datefield">
              <label className="prop-label">{t("available_date")}</label>
              <DateRangePicker
                type="th"
                className="prop-field"
                value={filter.available}
                onChange={(value) => this.setFilter({ available: value })}
              />
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("owner_admin")}</label>
              {select("admin", this.state.admins.map((a) => ({ value: a.uid, label: a.full_name })))}
            </div>
            <div className="col-xl-6">
              <label className="prop-label">{t("more_options")}</label>
              <div className="d-flex flex-wrap gap-2">
                {check("has_photo", "has_photo")}
                {check("has_video", "has_video")}
                {check("co_agent", "co_agent_open")}
              </div>
            </div>
          </div>

          <div className="d-flex flex-wrap justify-content-end gap-2 mt-4">
            <button type="button" className="prop-btn prop-btn--ghost" onClick={this.SaveSearch}>
              <span className="icon text-14">{""}</span>
              {t("save_search")}
            </button>
            <button type="button" className="prop-btn" onClick={() => this.Get(1)}>
              <span className="icon text-14">{""}</span>
              {t("search")}
            </button>
          </div>
        </div>
      </div>
    );
  };

  /* =================================================== render : แถบผลการค้นหา */
  renderToolbar = () => {
    const { count, sort, view, data, selected } = this.state;
    const pageIds = data.map((e) => e.uid);
    const allOnPage = pageIds.length > 0 && pageIds.every((id) => selected.includes(id));

    return (
      <div className="prop-card prop-in p-3 mb-3">
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
          <div className="d-flex align-items-center gap-3">
            <label className="d-flex align-items-center gap-2 mb-0 pointer" title={t("select_page")}>
              <input
                type="checkbox"
                className="form-check-input mt-0"
                style={{ accentColor: "var(--prop-lime-lo)" }}
                checked={allOnPage}
                onChange={this.toggleSelectPage}
              />
            </label>
            <div>
              <span className="fw-bold text-dark">{t("search_results")}</span>
              <span className="fw-bold ms-2" style={{ color: "#4d7c0f" }}>{money(count)}</span>
              <span className="text-secondary text-12 ms-1">{t("unit_items")}</span>
            </div>
          </div>

          <div className="d-flex flex-wrap align-items-center gap-2">
            <span className="text-secondary text-12">{t("sort_by")}</span>
            <Select
              className="prop-field prop-select wpx-220"
              default={false}
              placeholder={t("sort_by")}
              value={sort}
              options={SORTS.map((s) => ({ value: s.value, label: t(s.label) }))}
              onChange={(value) => value && this.Get(1, this.state.applied, value)}
            />
            <div className="prop-toggle">
              <button
                type="button"
                title={t("list_view")}
                className={`prop-toggle__btn icon ${view === "list" ? "is-active" : ""}`}
                onClick={() => this.setState({ view: "list" })}
              >
                {""}
              </button>
              <button
                type="button"
                title={t("grid_view")}
                className={`prop-toggle__btn icon ${view === "grid" ? "is-active" : ""}`}
                onClick={() => this.setState({ view: "grid" })}
              >
                {""}
              </button>
            </div>
            <button type="button" className="prop-btn prop-btn--ghost" onClick={this.ExportExcel}>
              <span className="icon text-14">{""}</span>
              {t("export_excel")}
            </button>
          </div>
        </div>
      </div>
    );
  };

  renderBulkBar = () => {
    const { selected } = this.state;
    if (!selected.length) return null;
    return (
      <div className="prop-bulk prop-in mb-3">
        <div className="d-flex align-items-center gap-2 text-14 fw-semibold" style={{ color: "var(--prop-ink)" }}>
          <span className="icon">{""}</span>
          {t("selected_count")} {selected.length} {t("unit_items")}
        </div>
        <div className="d-flex flex-wrap gap-2">
          <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.ExportExcel}>
            <span className="icon text-12">{""}</span>
            {t("export_selected")}
          </button>
          <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={() => this.setState({ selected: [] })}>
            <span className="icon text-12">{""}</span>
            {t("clear_selection")}
          </button>
        </div>
      </div>
    );
  };

  /* ==================================================== render : แถบด้านซ้าย */
  renderSidebar = () => {
    const { applied, saved } = this.state;
    const chips = this.filterChips(applied);

    return (
      <div className="d-flex flex-column gap-3" style={{ position: "sticky", top: "82px" }}>
        <div className="prop-card prop-in">
          <div className="prop-card__head py-3 px-3">
            <span className="prop-title text-14">
              <span className="prop-title__dot" />
              {t("filter_summary")}
            </span>
            {!!chips.length && (
              <button type="button" className="prop-link" onClick={this.clearAll}>
                {t("clear_all")}
              </button>
            )}
          </div>
          <div className="p-3">
            {chips.length ? (
              <div className="d-flex flex-wrap gap-2">
                {chips.map((chip, i) => (
                  <span key={i} className="prop-chip">
                    <span className="text-truncate" style={{ maxWidth: "150px" }}>{chip.text}</span>
                    <button type="button" className="prop-chip__x icon" title={t("delete")} onClick={() => this.removeChip(chip.patch)}>
                      {""}
                    </button>
                  </span>
                ))}
              </div>
            ) : (
              <div className="text-secondary text-12 text-center py-2">{t("no_filter_applied")}</div>
            )}
          </div>
        </div>

        <div className="prop-card prop-in">
          <div className="prop-card__head py-3 px-3">
            <span className="prop-title text-14">
              <span className="prop-title__dot" />
              {t("saved_searches")}
            </span>
          </div>
          <div className="p-2">
            {saved.map((s) => (
              <button key={s.uid} type="button" className="prop-saved" onClick={() => this.applySaved(s)}>
                <span className="icon prop-saved__icon">{""}</span>
                <span className="flex-grow-1 text-truncate">{s.name}</span>
              </button>
            ))}
            {!saved.length && <div className="text-secondary text-12 text-center py-3">{t("no_data")}</div>}
          </div>
        </div>
      </div>
    );
  };

  /* ================================================ render : การ์ดทรัพย์ 1 ใบ */
  renderItem = (item) => {
    const { selected, menu_open, view, fav_pop } = this.state;
    // ประเภททรัพย์ติดมากับ record อยู่แล้ว (ชื่อ ไอคอน สีการ์ด) ไม่ต้องไปหาจากรายการ master ซ้ำ
    const meta = item.asset_category || {};
    const status = statusMeta(item.status);
    const checked = selected.includes(item.uid);
    const favorite = !!item.favorite;

    // key ใช้เฉพาะตอนเรียกในลูป (ที่จอดรถ) — ที่เหลือเขียนตรง ๆ ไม่ต้องมี
    const spec = (icon, value, key) => (
      <span className="prop-spec" key={key}>
        <span className="icon">{icon}</span>
        {value}
      </span>
    );

    return (
      <div
        key={item.uid}
        className={`prop-item ${checked ? "is-checked" : ""} ${menu_open === item.uid ? "is-menu-open" : ""}`}
      >
        {/* รูปทรัพย์ */}
        <div className="prop-thumb" style={{ background: meta.grad }}>
          {item.image ? (
            <img src={item.image} alt={item.title} className="prop-thumb__img" />
          ) : (
            <span className="prop-thumb__ghost icon">{meta.icon}</span>
          )}
          <span className="prop-thumb__scrim" />
          <span className="prop-thumb__badge" style={{ backgroundColor: status.tint, color: status.color }}>
            {t(status.label)}
          </span>
          <button
            type="button"
            className={`prop-thumb__fav ${favorite ? "is-on" : ""} ${fav_pop === item.uid ? "is-pop" : ""}`}
            title={t("favorites")}
            aria-pressed={favorite}
            onClick={() => this.toggleFavorite(item)}
          >
            <svg viewBox="0 0 512 512" width="18" height="15" aria-hidden="true">
              <path
                d={HEART_PATH}
                fill={favorite ? "currentColor" : "none"}
                stroke="currentColor"
                strokeWidth={favorite ? 0 : 44}
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <span className="prop-thumb__count">
            <span className="icon text-10">{""}</span>
            {item.photos}
            {item.has_video && <span className="icon text-10 ms-1">{""}</span>}
          </span>
          {view === "grid" && (
            <span className="prop-item__check">
              <input type="checkbox" checked={checked} onChange={() => this.toggleSelect(item.uid)} />
            </span>
          )}
        </div>

        {/* ข้อมูลทรัพย์ */}
        <div className="prop-item__body">
          <div className="prop-item__title-row">
            <span className="prop-item__name pointer" onClick={() => this.ViewDetail(item)}>
              {item.title}
            </span>
            <span className="prop-tag">{categoryName(item.asset_category)}</span>
            {item.co_agent && (
              <span className="prop-tag" style={{ background: "#e0e7ff", borderColor: "#c7d2fe", color: "#3730a3" }}>
                Co-Agent
              </span>
            )}
          </div>

          <div className="prop-addr mt-2">
            <span className="icon text-10">{""}</span>
            <span className="text-truncate">{item.address}</span>
          </div>

          <div className="prop-specs mt-2">
            {!!item.bedroom && spec("", `${item.bedroom} ${t("bed_unit")}`)}
            {!!item.bathroom && spec("", `${item.bathroom} ${t("bath_unit")}`)}
            {!!item.area && spec("", `${item.area} ${t("sqm")}`)}
            {!!item.land_area && spec("", `${item.land_area} ${t("sqw")}`)}
            {!!item.floor && spec("", `${t("floor_label")} ${item.floor}${item.building ? ` ${t("building_label")} ${item.building}` : ""}`)}
            {parkingTypes(item).map((e) => spec(e.icon, parkingCount(item, e) ? `${t(e.label)} ${parkingCount(item, e)} ${t("car_unit")}` : t(e.label), e.value))}
          </div>

          <div className="d-flex flex-wrap align-items-baseline gap-3 mt-2">
            {isRentDeal(item.deals) && (
              <span className="prop-price">
                {t("rent_price")} {money(item.rent)} <span className="prop-price__unit">{t("baht_per_month")}</span>
              </span>
            )}
            {isSaleDeal(item.deals) && (
              <span className="prop-price prop-price--sale">
                {t("sale_price")} {money(item.price)} <span className="prop-price__unit">{t("unit_baht")}</span>
              </span>
            )}
          </div>

          <div className="text-secondary text-10 mt-2">
            {item.code} · {t("updated")} {dateTH(item.updated_at)}
          </div>
        </div>

        {/* ผู้ดูแล + ปุ่มจัดการ */}
        <div className="prop-item__side">
          {/* ผู้ดูแล + วันว่าง วางบนสุดคู่กับ checkbox */}
          <div className="d-flex align-items-start justify-content-between gap-2">
            <div className="d-flex flex-column gap-2 overflow-hidden">
              <div className="prop-meta">
                <span className="icon">{""}</span>
                <span className="text-truncate">{item.admin_name}</span>
              </div>
              <div className="prop-meta">
                <span className="icon">{""}</span>
                <span>
                  {t("vacant_from")} {dateTH(item.available_at)}
                </span>
              </div>
            </div>
            {view === "list" && (
              <span className="prop-item__check">
                <input type="checkbox" checked={checked} onChange={() => this.toggleSelect(item.uid)} />
              </span>
            )}
          </div>

          <div className="d-flex align-items-center justify-content-end gap-2 mt-auto">
            <button type="button" className="prop-iconbtn icon" title={t("view_details")} aria-label={t("view_details")} onClick={() => this.ViewDetail(item)}>
              {""}
            </button>
            {can("assets.update") && (
              <button type="button" className="prop-iconbtn prop-iconbtn--dark icon" title={t("edit")} aria-label={t("edit")} onClick={() => this.Edit(item)}>
                {""}
              </button>
            )}
            {/* เมนูตัวเลือกเพิ่มเติม : ข้างในมีทำสำเนา (create) กับลบ (delete) */}
            {can(["assets.create", "assets.delete"]) && (
              <div className="position-relative">
                <button
                  type="button"
                  className="prop-iconbtn icon"
                  title={t("more_options")}
                  onClick={() => this.setState({ menu_open: menu_open === item.uid ? "" : item.uid })}
                >
                  {""}
                </button>
                {menu_open === item.uid && (
                  <>
                    <div className="position-fixed" style={{ inset: 0, zIndex: 1040 }} onClick={() => this.setState({ menu_open: "" })} />
                    <div className="prop-pop" style={{ bottom: "calc(100% + 8px)", top: "auto" }}>
                      {can("assets.create") && (
                        <button type="button" className="prop-pop__item" onClick={() => this.Duplicate(item)}>
                          <span className="icon">{""}</span>
                          {t("duplicate")}
                        </button>
                      )}
                      {/* <button type="button" className="prop-pop__item" onClick={() => this.CopyLink(item)}>
                        <span className="icon">{""}</span>
                        {t("copy_link")}
                      </button>
                      <button type="button" className="prop-pop__item" onClick={() => this.Archive(item)}>
                        <span className="icon">{""}</span>
                        {t("archive")}
                      </button> */}
                      <div className="prop-pop__sep" />
                      {can("assets.delete") && (
                        <button type="button" className="prop-pop__item is-danger" onClick={() => this.Delete(item)}>
                          <span className="icon">{""}</span>
                          {t("delete")}
                        </button>
                      )}
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  renderResults = () => {
    const { data, view, count, page } = this.state;

    if (!data.length) {
      return (
        <div className="prop-card prop-in">
          <div className="prop-empty">
            <div className="prop-empty__icon icon">{""}</div>
            <div className="fw-bold text-dark mb-1">{t("no_properties_found")}</div>
            <div className="text-12">{t("try_adjust_filters")}</div>
            <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm mt-3" onClick={this.clearAll}>
              <span className="icon text-12">{""}</span>
              {t("clear_all")}
            </button>
          </div>
        </div>
      );
    }

    const from = (page - 1) * PAGE_SIZE + 1;
    const to = Math.min(page * PAGE_SIZE, count);

    return (
      <>
        <div className={view === "grid" ? "prop-grid" : "prop-list"}>
          {data.map((item) => this.renderItem(item))}
        </div>

        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mt-4 text-secondary text-12">
          <div>
            {t("showing")} {from}-{to} {t("of")} {money(count)} {t("unit_items")}
          </div>
          <Pagination
            className="mb-0"
            page={page}
            count={Math.ceil(count / PAGE_SIZE) || 1}
            showFirstButton={false}
            showLastButton={false}
            onChange={(_, next) => {
              this.Get(next, this.state.applied);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          />
        </div>
      </>
    );
  };

  /* ============================================ render : โมดัลรายละเอียดทรัพย์
   * รวมข้อมูลทั้งประกาศไว้ที่เดียว โดยแบ่งตามคนที่ใช้ข้อมูล —
   *   คอลัมน์ซ้าย  = สิ่งที่ลูกค้าเห็นบนเว็บ (รูป สเปก รายละเอียด สิ่งอำนวยความสะดวก)
   *   คอลัมน์ขวา   = ข้อมูลที่ทีมงานใช้ทำงาน (ที่ตั้ง การเงิน เจ้าของ ผู้ดูแล)
   * การ์ดข้อมูลภายในใช้โทนอุ่นเพื่อให้เห็นชัดว่าไม่ได้ออกหน้าเว็บ
   * ------------------------------------------------------------------------- */
  renderDetail = () => {
    const { detail: d, detail_open, detail_photo, detail_lang } = this.state;
    if (!d) return null;

    const meta = d.asset_category || {};
    const status = statusMeta(d.status);
    const publish = PUBLISH_META[d.publish_status] || PUBLISH_META.draft;

    const photos = d.photos || [];
    const index = photos.length ? Math.min(detail_photo, photos.length - 1) : 0;
    const cover = (photos.find((e) => e.uid === d.cover) || photos[0])?.file_path || "";

    // ที่ดินคิดขนาดเป็นตารางวา ประเภทอื่นเป็นพื้นที่ใช้สอยตารางเมตร
    const land = !d.area && !!d.land_area;
    const size = land ? d.land_area : d.area;
    const sizeUnit = land ? t("sqw") : t("sqm");

    /* -------------------------------------------------- ชิ้นส่วนที่ใช้ซ้ำ */
    const card = (icon, title, body, opts = {}) => (
      <div className={`av-card ${opts.internal ? "av-card--internal" : ""}`}>
        <div className="av-card__head">
          <span className="av-card__title">
            <span className="av-card__icon icon">{icon}</span>
            {title}
          </span>
          {opts.extra}
        </div>
        <div className="av-card__body">{body}</div>
      </div>
    );

    // ช่องที่ไม่มีข้อมูลจะไม่ถูกแสดงเลย ดีกว่าโชว์ "-" เต็มไปหมด
    const blank = (value) => value === null || value === undefined || value === "" || value === 0;

    const row = (label, value) =>
      blank(value) ? null : (
        <div className="av-row" key={label}>
          <div className="av-row__label">{label}</div>
          <div className="av-row__value">{value}</div>
        </div>
      );

    const line = (label, value) =>
      blank(value) ? null : (
        <div className="av-line" key={label}>
          <span className="av-line__label">{label}</span>
          <span className="av-line__value">{value}</span>
        </div>
      );

    const empty = (icon, text) => (
      <div className="av-empty">
        <span className="av-empty__icon icon">{icon}</span>
        {text}
      </div>
    );

    // ไฟล์เปิดในแท็บใหม่เสมอ — ไม่ดึงมาแสดงในโมดัลเพราะเป็นได้ทั้ง pdf และรูป
    const fileLink = (item, key) => (
      <a key={key} className="av-file" href={item.file_path} target="_blank" rel="noreferrer">
        <span className="av-file__icon icon">{""}</span>
        <span className="av-file__name text-truncate">{item.file_name || t("open_file")}</span>
        <span className="av-file__go icon">{""}</span>
      </a>
    );

    const chips = (items, className = "") => <div className="av-chips">{items.map((e, i) => <span key={i} className={`av-chip ${className}`}>{e}</span>)}</div>;

    /* --------------------------------------------- ตัวเลขสำคัญบนหัวเนื้อหา */
    const keys = [];
    if (isRentDeal(d.deals)) keys.push({ icon: "", label: t("rent_price"), value: money(d.rent), unit: t("baht_per_month"), accent: true });
    if (isSaleDeal(d.deals)) keys.push({ icon: "", label: t("sale_price"), value: money(d.price), unit: t("unit_baht"), accent: true });
    if (size) keys.push({ icon: land ? "" : "", label: land ? t("land_area") : t("area_size"), value: decimal(size), unit: sizeUnit });
    if (d.bedroom) keys.push({ icon: "", label: t("bedrooms"), value: d.bedroom, unit: t("bed_unit") });
    if (d.bathroom) keys.push({ icon: "", label: t("bathrooms"), value: d.bathroom, unit: t("bath_unit") });
    if (d.living_room) keys.push({ icon: "", label: t("living_room"), value: d.living_room, unit: t("room_unit") });
    if (d.kitchen) keys.push({ icon: "", label: t("kitchen"), value: d.kitchen, unit: t("room_unit") });
    // ที่จอดรถไม่ใช่ตัวเลขแล้ว จึงย้ายลงไปอยู่ในตาราง "ข้อมูลจำเพาะ" ด้านล่างแทนแถบตัวเลข

    /* ------------------------------------------------- รายละเอียดประกาศ */
    const langs = DESC_LANGS.filter((e) => (d[e.field] || "").trim());
    const lang = langs.find((e) => e.value === detail_lang) || langs[0];

    /* ------------------------------------------------- ข้อมูลจำเพาะ */
    const specs = [
      row(t("property_type"), categoryName(d.asset_category)),
      row(t("project"), d.project),
      row(t("floor_label"), d.floor ? `${d.floor}${d.building ? ` · ${t("building_label")} ${d.building}` : ""}` : ""),
      // จำนวนชั้นของตัวบ้าน — มีเฉพาะประเภทแนวราบ
      row(t("floor_count"), d.floor_count ? `${d.floor_count} ${t("floor_label")}` : ""),
      row(t("parking"), parkingLabel(d)),
      row(t("direction"), d.direction ? t(directionMeta(d.direction)?.label || "") : ""),
      row(t("built_year"), d.built_year),
      // ที่ดินโชว์ขนาดที่ดินไปแล้วในแถบด้านบน ตรงนี้จึงโชว์เฉพาะกรณีมีทั้งสองค่า
      row(t("land_area"), !land && d.land_area ? `${decimal(d.land_area)} ${t("sqw")}` : ""),
      row(t("available_date"), d.available_at ? dateTH(d.available_at) : ""),
      row(t("price_per_sqm"), d.price && d.area ? `${money(d.price / d.area)} ${t("unit_baht")}` : ""),
    ].filter(Boolean);

    /* ------------------------------------------------- ตำแหน่งที่ตั้ง */
    const place = [
      line(t("soi"), d.soi),
      line(t("subdistrict"), d.subdistrict),
      line(t("zone_district"), d.district),
      line(t("province"), d.province),
      line(t("postcode"), d.postcode),
      line(t("coordinates"), d.latitude && d.longitude ? `${d.latitude}, ${d.longitude}` : ""),
    ].filter(Boolean);

    /* ------------------------------------------------- ข้อมูลการเงิน */
    const finance = [
      // ระยะสัญญาเช่า — 0 หรือไม่ระบุ = ไม่กำหนดขั้นต่ำ ไม่ต้องขึ้นบรรทัด
      line(t("contract_term"), d.contract_term ? `${d.contract_term} ${t(contractUnitMeta(d.contract_unit).label)}` : ""),
      line(t("deposit"), d.deposit ? `${money(d.deposit)} ${t("unit_baht")}` : ""),
      line(t("advance_payment"), d.advance_month ? `${d.advance_month} ${t("unit_months")}` : ""),
      line(t("move_in_payment"), d.move_in_payment ? `${money(d.move_in_payment)} ${t("unit_baht")}` : ""),
      line(t("water_fee"), d.water_fee ? `${money(d.water_fee)} ${t("unit_baht")}` : ""),
      line(t("common_fee"), d.common_fee_month ? `${money(d.common_fee_month)} ${t("unit_baht")}` : ""),
      // ค่าส่วนกลางต่อเดือน — ต่อท้ายว่ารวมอยู่ในค่าเช่าแล้วหรือยัง
      line(
        t("common_fee_amount"),
        d.common_fee ? `${money(d.common_fee)} ${t("baht_per_month")}${d.common_fee_included ? ` · ${t("detail_cost_included_in_rent")}` : ""}` : ""
      ),
      line(t("special_terms"), d.special_terms),
      line(t("co_agent"), d.co_agent_use ? t("co_agent_yes") : t("co_agent_no")),
      d.co_agent_use ? line(t("co_agent_share"), d.co_agent_share ? `${decimal(d.co_agent_share)}%` : "") : null,
      d.co_agent_use ? line(t("co_agent_name"), d.co_agent_name) : null,
      d.co_agent_use ? line(t("co_agent_phone"), d.co_agent_phone) : null,
    ].filter(Boolean);

    /* ------------------------------------------------- ข้อมูลภายใน */
    const owner = [
      line(t("owner_name"), d.owner_name),
      line(t("owner_phone"), d.owner_phone),
      line(t("owner_line"), d.owner_line),
      line(t("owner_facebook"), d.owner_facebook),
      line(t("owner_email"), d.owner_email),
    ].filter(Boolean);

    const hasInternal = owner.length || d.internal_note || d.owner_overseas || (d.documents || []).length;

    return (
      <Modal show={detail_open} onHide={this.CloseDetail} size="xl" centered scrollable dialogClassName="av-dialog" contentClassName="av-content">
        {/* ---------------------------------------------------- หัวโมดัล */}
        <Modal.Header className="av-head">
          <div className="av-hero" style={cover ? { backgroundImage: `url(${cover})` } : { background: meta.grad }}>
            {!cover && <span className="av-hero__ghost icon">{meta.icon}</span>}
            <span className="av-hero__scrim" />

            <div className="av-hero__body">
              <div className="av-badges">
                <span className="av-pill" style={{ backgroundColor: status.tint, color: status.color }}>
                  {t(status.label)}
                </span>
                <span className="av-pill" style={{ backgroundColor: publish.tint, color: publish.color }}>
                  <span className="icon text-10">{publish.icon}</span>
                  {t(publish.label)}
                </span>
                {DEALS.filter((e) => (d.deals || []).includes(e.value)).map((e) => (
                  <span key={e.value} className="av-pill av-pill--glass">
                    {t(e.label)}
                  </span>
                ))}
                {d.co_agent_use && <span className="av-pill av-pill--glass">Co-Agent</span>}
                {d.is_archived && (
                  <span className="av-pill av-pill--glass">
                    <span className="icon text-10">{""}</span>
                    {t("archived")}
                  </span>
                )}
              </div>

              <h5 className="av-hero__title">{d.title}</h5>

              <div className="av-hero__meta">
                <span className="av-hero__code">{d.code}</span>
                <span>{categoryName(d.asset_category)}</span>
                {!!d.address && (
                  <span className="av-hero__addr">
                    <span className="icon text-10">{""}</span>
                    {d.address}
                  </span>
                )}
              </div>
            </div>
          </div>
        </Modal.Header>

        {/* --------------------------------------------------- เนื้อโมดัล */}
        <Modal.Body className="av-body">
          {!!keys.length && (
            <div className="av-keys">
              {keys.map((e, i) => (
                <div key={i} className={`av-key ${e.accent ? "av-key--accent" : ""}`}>
                  <div className="av-key__label">
                    <span className="icon">{e.icon}</span>
                    {e.label}
                  </div>
                  <div className="av-key__value">
                    {e.value}
                    <span className="av-key__unit">{e.unit}</span>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="row g-3">
            {/* ------------------------------------------ ซ้าย : สิ่งที่ลูกค้าเห็น */}
            <div className="col-lg-7">
              {card(
                "",
                t("photos"),
                photos.length ? (
                  <>
                    <div className="av-gallery__main">
                      <img src={photos[index].file_path} alt={`${d.title} ${index + 1}`} />
                      {photos.length > 1 && (
                        <>
                          <button
                            type="button"
                            className="av-gallery__nav av-gallery__nav--prev icon"
                            aria-label={t("previous")}
                            onClick={() => this.setState({ detail_photo: (index - 1 + photos.length) % photos.length })}
                          >
                            {""}
                          </button>
                          <button
                            type="button"
                            className="av-gallery__nav av-gallery__nav--next icon"
                            aria-label={t("next")}
                            onClick={() => this.setState({ detail_photo: (index + 1) % photos.length })}
                          >
                            {""}
                          </button>
                        </>
                      )}
                      <span className="av-gallery__index">
                        {index + 1} / {photos.length}
                      </span>
                    </div>

                    {photos.length > 1 && (
                      <div className="av-thumbs">
                        {photos.map((photo, i) => (
                          <button
                            key={photo.uid || i}
                            type="button"
                            className={`av-thumb ${i === index ? "is-active" : ""}`}
                            onClick={() => this.setState({ detail_photo: i })}
                          >
                            <img src={photo.file_path} alt={`${d.title} ${i + 1}`} />
                          </button>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  empty("", t("no_photo_yet"))
                ),
                { extra: <span className="av-card__count">{photos.length} {t("unit_items")}</span> }
              )}

              {!!specs.length && card("", t("spec_detail"), <div className="av-rows">{specs}</div>)}

              {card(
                "",
                t("description"),
                lang ? <div className="av-desc">{d[lang.field]}</div> : empty("", t("no_description_yet")),
                {
                  extra: langs.length > 1 && (
                    <div className="av-tabs">
                      {langs.map((e) => (
                        <button
                          key={e.value}
                          type="button"
                          className={`av-tab ${lang?.value === e.value ? "is-active" : ""}`}
                          onClick={() => this.setState({ detail_lang: e.value })}
                        >
                          {t(e.label)}
                        </button>
                      ))}
                    </div>
                  ),
                }
              )}

              {card(
                "",
                t("amenities"),
                (d.amenities || []).length || d.amenity_other ? (
                  <div className="av-chips">
                    {(d.amenities || []).map((value) => {
                      const item = amenityMeta(value);
                      return (
                        <span key={value} className="av-chip">
                          {!!item?.icon && <span className="icon">{item.icon}</span>}
                          {item ? t(item.label) : value}
                        </span>
                      );
                    })}
                    {!!d.amenity_other && <span className="av-chip av-chip--plain">{d.amenity_other}</span>}
                  </div>
                ) : (
                  empty("", t("no_amenity"))
                )
              )}

              {/* ส่วนกลางของโครงการ + การตกแต่ง / เฟอร์นิเจอร์ / สัตว์เลี้ยง
                  สัตว์เลี้ยงโชว์เสมอ เพราะเป็นคำถามที่ผู้เช่าถามทุกราย ตอบว่า "ไม่อนุญาต" ก็ต้องเห็น */}
              {card(
                "",
                t("project_facilities"),
                <>
                  {!!(d.facilities || []).length && (
                    <div className="av-chips">
                      {(d.facilities || []).map((value) => {
                        const item = facilityMeta(value);
                        return (
                          <span key={value} className="av-chip">
                            {!!item?.icon && <span className="icon">{item.icon}</span>}
                            {value === "other" && d.facility_other ? d.facility_other : item ? t(item.label) : value}
                          </span>
                        );
                      })}
                    </div>
                  )}
                  <div className="av-chips mt-2">
                    {!!decorationMeta(d.decoration) && <span className="av-chip av-chip--soft">{t(decorationMeta(d.decoration).label)}</span>}
                    {!!furnishMeta(d.furnished) && <span className="av-chip av-chip--soft">{t(furnishMeta(d.furnished).label)}</span>}
                    <span className="av-chip av-chip--soft">
                      {t("pet")} : {t(d.pet_allowed ? "pet_allowed" : "pet_not_allowed")}
                    </span>
                  </div>
                </>
              )}

              {card(
                "",
                t("highlights_tags"),
                (d.tags || []).length || (d.keywords || []).length ? (
                  <>
                    {!!(d.tags || []).length && chips((d.tags || []).map((value) => (tagMeta(value) ? t(tagMeta(value).label) : value)), "av-chip--soft")}
                    {!!(d.keywords || []).length && (
                      <>
                        <div className="av-row__label mt-3 mb-2">{t("keyword_th")}</div>
                        {chips(d.keywords, "av-chip--plain")}
                      </>
                    )}
                  </>
                ) : (
                  empty("", t("no_tag"))
                )
              )}

              {!!(d.nearby || []).length &&
                card(
                  "",
                  t("nearby_places"),
                  (d.nearby || []).map((item, i) => {
                    const type = nearbyMeta(item.type);
                    return (
                      <div className="av-near" key={i}>
                        <span className="av-near__icon icon">{type.icon}</span>
                        <span className="av-near__name text-truncate">
                          {item.label}
                          <span className="av-near__type ms-2">{t(type.label)}</span>
                        </span>
                        {!blank(item.distance) && <span className="av-near__dist">{decimal(item.distance)} {t("unit_km_short")}</span>}
                      </div>
                    );
                  })
                )}

              {!!(d.floor_plans || []).length &&
                card(
                  "",
                  t("floor_plan"),
                  <div className="av-plans">
                    {d.floor_plans.map((plan, i) => (
                      <a key={plan.uid || i} className="av-plan" href={plan.file_path} target="_blank" rel="noreferrer">
                        <img src={plan.file_path} alt={`${t("floor_plan")} ${i + 1}`} />
                      </a>
                    ))}
                  </div>
                )}

              {!!d.video_url &&
                card(
                  "",
                  t("video_or_link"),
                  <a className="av-file" href={d.video_url} target="_blank" rel="noreferrer">
                    <span className="av-file__icon icon">{""}</span>
                    <span className="av-file__name text-truncate">{d.video_url}</span>
                    <span className="av-file__go">{t("watch_video")}</span>
                  </a>
                )}
            </div>

            {/* ------------------------------------------ ขวา : ข้อมูลการทำงาน */}
            <div className="col-lg-5">
              {card(
                "",
                t("location"),
                <>
                  {place.length ? place : empty("", t("no_data"))}
                  {!!(d.latitude && d.longitude) && (
                    <a
                      className="prop-btn prop-btn--ghost prop-btn--sm w-100 mt-3"
                      href={`https://www.google.com/maps/search/?api=1&query=${d.latitude},${d.longitude}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="icon text-12">{""}</span>
                      {t("open_google_maps")}
                    </a>
                  )}
                </>
              )}

              {!!finance.length && card("", t("finance_info"), finance)}

              {!!hasInternal &&
                card(
                  "",
                  t("summary_internal"),
                  <>
                    {owner}
                    {!!d.owner_overseas && (
                      <div className="mt-2">
                        <span className="av-chip av-chip--plain">
                          <span className="icon">{""}</span>
                          {t("owner_overseas")}
                        </span>
                      </div>
                    )}
                    {!!d.internal_note && (
                      <>
                        <div className="av-row__label mt-3">{t("internal_note")}</div>
                        <div className="av-desc mt-1">{d.internal_note}</div>
                      </>
                    )}
                    {!!(d.documents || []).length && (
                      <>
                        <div className="av-row__label mt-3 mb-2">{t("documents")}</div>
                        {d.documents.map((doc, i) => fileLink(doc, doc.uid || i))}
                      </>
                    )}
                  </>,
                  {
                    internal: true,
                    extra: (
                      <span className="av-tagline">
                        <span className="icon text-10">{""}</span>
                        {t("internal_only")}
                      </span>
                    ),
                  }
                )}

              {card(
                "",
                t("admin_stats"),
                [
                  line(t("owner_admin"), d.admin_name),
                  line(t("views_count"), `${money(d.views)} ${t("unit_views")}`),
                  line(t("publish_date"), d.published_at ? dateTH(d.published_at) : ""),
                  line(t("created_date"), dateTH(d.created_at)),
                  line(t("updated_date"), dateTH(d.updated_at)),
                ].filter(Boolean)
              )}
            </div>
          </div>
        </Modal.Body>

        {/* ---------------------------------------------------- ท้ายโมดัล
            โมดัลนี้เป็นหน้าดูข้อมูลอย่างเดียว ปุ่มที่แก้ข้อมูลได้อยู่บนการ์ดในรายการ */}
        <Modal.Footer className="av-foot">
          <div className="text-secondary text-12">
            {d.code} · {t("updated")} {dateTH(d.updated_at)}
          </div>
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseDetail}>
            {t("close")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          {/* หัวข้อหน้า */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("all_properties")}</h3>
              <div className="text-secondary text-14">{t("property_list_subtitle")}</div>
            </div>
            {can("assets.create") && (
              <button type="button" className="prop-btn" onClick={() => this.props.router.navigate("/ad/assets/create")}>
                <span className="icon text-14">{""}</span>
                {t("add_property")}
              </button>
            )}
          </div>

          {this.renderDetail()}

          {this.renderFilterPanel()}
          {this.renderToolbar()}
          {this.renderBulkBar()}

          <div className="row g-3">
            <div className="col-xl-3 col-lg-4">{this.renderSidebar()}</div>
            <div className="col-xl-9 col-lg-8">{this.renderResults()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(PropertyAll);
